import React from 'react';

// @mui
import { Link, TableCell } from '@mui/material';

export default class GridUrlCell extends React.Component {
    render() {
        // props: value, id, field
        let id = this.props.field.id;
        let url = this.props.value ? (this.props.value.match(/^(http|https):\/\//) ? this.props.value : 'http://' + this.props.value) : '';
        const baseStyle = this.props.styles;
        return (
            <TableCell key={id} align="left" sx={{ ...baseStyle }}>
                <Link href={url} target="_blank" rel="noopener">
                    {url}
                </Link>
            </TableCell>
        );
    }
}
